import React, { Component } from 'react';

// Components
import Icon from '../../../../../components/Icon';
import TagList from '../../../components/AdminTable/TagList';
import SubscriberForm from './SubscriberForm';

// util
import { notificationTypeToLabel } from '../../../shared/notification-types';

// css
import './styles.css';
import Button from '../../../../../components/Button';

class SubscribersTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeSubscriberEditIndex: null,
      activeDeletePromptIndex: null,
    };
  }

  _renderSubscriberNotificationArray = notificationList => (
    notificationList
      .filter(notification => notification.active)
      .map(notification => ({
        name: notificationTypeToLabel[notification.type],
      }))
  )

  _toggleSubscriberEdit = (subscriberIndex) => {
    this._dismissSubscriberEdit();

    this.setState({
      activeSubscriberEditIndex: subscriberIndex,
    });
  }

  _dismissSubscriberEdit = () => {
    this.setState({
      activeSubscriberEditIndex: null,
    });
  }

  _toggleDeletePrompt = (subscriberIndex) => {
    this.setState({
      activeDeletePromptIndex: subscriberIndex,
    });
  }

  _dismissDeletePrompt = () => {
    this.setState({
      activeDeletePromptIndex: null,
    });
  }

  _handleSubscriberEdit = (values, subscriber) => {
    const { onSubEdit } = this.props;

    onSubEdit(values, subscriber);
  }

  render() {
    const {
      subscribers,
      onSubDelete,
    } = this.props;

    return (
      <table className="SubscribersTable__table">
        <thead>
          <tr className="SubscribersTable__table-thead-row">
            <th className="SubscribersTable__table-item--left">Nome</th>
            <th className="SubscribersTable__table-item--left">Email</th>
            <th className="SubscribersTable__table-item--left">Notificações Ativas</th>
            <th className="SubscribersTable__table-item--center">Editar</th>
            <th className="SubscribersTable__table-item--center">Excluir</th>
          </tr>
        </thead>

        <tbody>
          {
            subscribers.map((subscriber, index) => {
              const { activeSubscriberEditIndex, activeDeletePromptIndex } = this.state;

              // ================================
              // ACTIVE EDIT
              // ================================
              if (index === activeSubscriberEditIndex) {
                return (
                  <tr key={subscriber.email}>
                    <td colSpan="5">
                      <SubscriberForm
                        onDismiss={this._dismissSubscriberEdit}
                        onSubmit={(values) => { this._handleSubscriberEdit(values, subscriber); }}
                        userData={subscriber}
                        enableReinitialize
                      />
                    </td>
                  </tr>
                );
              }

              // ================================
              // ACTIVE DELETE PROMPT
              // ================================
              if (index === activeDeletePromptIndex) {
                return (
                  <tr key={subscriber.email} className="Su">
                    <td colSpan="5">
                      <div className="SubscribersTable__delete-prompt">
                        Deseja excluir este usuário?

                        <Button
                          skin="gray-light"
                          text="Cancelar"
                          className="SubscribersTable__delete-prompt-button"
                          onClick={this._dismissDeletePrompt}
                        />

                        <Button
                          skin="danger"
                          text="Excluir"
                          className="SubscribersTable__delete-prompt-button"
                          onClick={() => { onSubDelete(subscriber.id); }}
                        />
                      </div>
                    </td>
                  </tr>
                );
              }


              // ================================
              // NORMAL STATE
              // ================================
              if (index !== activeSubscriberEditIndex) {
                return (
                  <tr key={subscriber.email} className="SubscribersTable__table-row">
                    <td>
                      {subscriber.name}
                    </td>
                    <td className="SubscribersTable__table-item--highlight">
                      {subscriber.email}
                    </td>
                    <td>
                      <TagList
                        tagData={this._renderSubscriberNotificationArray(subscriber.typeNotification)}
                      />
                    </td>
                    <td
                      className="SubscribersTable__table-item--icon SubscribersTable__table-item--icon-secondary SubscribersTable__table-item--center"
                      onClick={() => { this._toggleSubscriberEdit(index); }}
                    >
                      <Icon name="mode_edit" />
                    </td>
                    <td
                      className="SubscribersTable__table-item--icon SubscribersTable__table-item--icon-light-gray SubscribersTable__table-item--center"
                      onClick={() => { this._toggleDeletePrompt(index); }}
                    >
                      <Icon name="delete" />
                    </td>
                  </tr>
                );
              }

              return '';
            })
          }
        </tbody>
      </table>
    );
  }
}

SubscribersTable.propTypes = {};
SubscribersTable.defaultProps = {};

export default SubscribersTable;
